const hashQrcode = window.location.hash;

if (hashQrcode.indexOf('/qr-code/') !== -1) {
    window.location.href = window.location.href.replace('/#/qr-code/', '/qr-code/');
}
